<div class="mobile-menus-screen">
	<h3><i class="mdi mdi-account-circle-outline"></i> {{user.username}}</h3>
	<ul>
		<!-- <li><a href="javascript:void(0)" routerLink="/profile">my profile</a></li> -->
		<!-- <li><a href="javascript:void(0)" routerLink="/reports/account-statement">rolling commission</a></li> -->
		<!-- <li><a href="javascript:void(0)" routerLink="/reports/account-statement">account statement</a></li> -->
		<!-- <li><a href="javascript:void(0)" routerLink="/my-bets">bets history</a></li> -->
		<!-- <li><a href="javascript:void(0)" routerLink="/reports/profit-loss">profit/loss</a></li> -->
		<!-- <li><a href="javascript:void(0)" (click)="settingModal.show()">stake setting</a></li> -->
		<!-- <li><a href="javascript:void(0)" routerLink="/market-analysis">Market Analysis</a></li> -->
        <li>
            <a href="javascript: void(0);" class="menu-link-redi" [routerLink]="['/settlement',user.id]">settlement</a>
        </li>
        <li>
            <a href="#collapse-cuser" data-bs-toggle="collapse">
                <span>  Create User</span>
            </a>
            <div class="collapse" id="collapse-cuser">
                <ul class="nav-second-level">
                    <li *ngFor="let item of env?.userList">
                        <a href="javascript: void(0);" *ngIf="item.cIds.includes(user?.role_id)" class="menu-link-redi" [routerLink]="['/user-create',user.id, item?.id]">Create New {{item?.name}}</a>
                    </li>
                </ul>
            </div>
        </li>
		<li>
            <a href="#collapse-user" data-bs-toggle="collapse">
                <span>  Users List</span>
            </a>
            <div class="collapse" id="collapse-user">
                <ul class="nav-second-level">
                    <li>
                        <a href="javascript: void(0);" class="menu-link-redi" [routerLink]="['/users/child',user.id]">My Child</a>
                        <a href="javascript: void(0);" class="menu-link-redi" [routerLink]="['/users/child_by_type/2']">Super Master</a>
                        <a href="javascript: void(0);" class="menu-link-redi" [routerLink]="['/users/child_by_type/3']">Master</a>
                        <a href="javascript: void(0);" class="menu-link-redi" [routerLink]="['/users/child_by_type/4']">Client</a>
                        <a href="javascript: void(0);" class="menu-link-redi" [routerLink]="['/users/blocked-child',user.id]">Blocked Users</a>
                    </li>
                </ul>
            </div>
        </li>
		<li>
			<a href="#collapse-report" data-bs-toggle="collapse">
                <span>  Reports</span>
            </a>
            <div class="collapse" id="collapse-report">
                <ul class="nav-second-level">
                    <li>
                        <a href="javascript: void(0);" class="menu-link-redi" [routerLink]="['/reports/account-statement-new',user.id]">Account statement</a>
                        <a href="javascript: void(0);" class="menu-link-redi" [routerLink]="['/reports/profit-loss',user.id]">profit loss</a>
                        <a href="javascript: void(0);" class="menu-link-redi" [routerLink]="['/reports/chip-statement',user.id]">chip statement</a>
                        <a href="javascript: void(0);" class="menu-link-redi" [routerLink]="['/reports/chip-summary',user.id]">balance summary</a>
                        <a href="javascript: void(0);" class="menu-link-redi" [routerLink]="['/reports/settlement-report',user.id]">settlement report</a>
                        <a href="javascript: void(0);" class="menu-link-redi" [routerLink]="['/reports/sport-report',user.id]">sport summary report</a>
                        <a href="javascript: void(0);" class="menu-link-redi" [routerLink]="['/reports/top-client',user.id]">top clients</a>
                        <a href="javascript: void(0);" class="menu-link-redi" [routerLink]="['/balance-sheet',user.id]">balance sheet</a>
                    </li>
                </ul>
            </div>
		</li>
		<li><a href="javascript:void(0)" routerLink="/change-password">Change Password</a></li>
		<!-- <li><a href="javascript:void(0)" routerLink="/reports/summary">active log</a></li> -->
	</ul>
	<a href="javascript:void(0)" (click)="logOut()" class="mbl-logout-btn">LOGOUT <i class="mdi mdi-logout"></i></a>
</div>


<!-- mobile stake modal -->
<div id="MobileStake" class="modal fade" bsModal #settingModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1"
    role="dialog" aria-labelledby="dialog-static-name">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h3 class="modal-title" id="MobileStakeLabel"><i class="mdi mdi-cog"></i> &nbsp; Setting</h3>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="settingModal.hide()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <!-- <div class="modal-body"> -->
            <app-stakes (close)="settingModal.hide()"></app-stakes>
            <app-loader class="full-overlay" *ngIf="isLoading"></app-loader>
            <!-- </div> -->
        </div>
    </div>
</div>
<!-- mobile stake modal -->